import React from "react";
import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export interface ExpandIconProps extends MuiIconExternalProps {
    isExpanded: boolean;
}

export const HorizontalExpandIcon = ({isExpanded, ...props}: ExpandIconProps) => {
    return (
        isExpanded
            ? <MuiIcon {...props}
            >{'\ue5ce'}</MuiIcon>
            : <MuiIcon {...props}
            >{'\ue5cf'}</MuiIcon>
    );
}
